import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Shared translations
import sharedEn from '../locales/en/shared.json';
import sharedEs from '../locales/es/shared.json';
import sharedHi from '../locales/hi/shared.json';
import sharedAr from '../locales/ar/shared.json';

const SUPPORTED_LANGUAGES = ['en', 'es', 'hi', 'ar'];

/**
 * Initialize i18n with shared translations.
 * Each app calls this with its own namespace translations.
 *
 * @param {string} appNamespace - The app's namespace name (e.g., 'zoom', 'teams')
 * @param {{ en: object, es: object, hi: object, ar: object }} appTranslations - App-specific translations per language
 */
export function initI18n(appNamespace, appTranslations = {}) {
  if (i18n.isInitialized) return i18n;

  const resources = {
    en: {
      shared: sharedEn,
      ...(appTranslations.en && { [appNamespace]: appTranslations.en }),
    },
    es: {
      shared: sharedEs,
      ...(appTranslations.es && { [appNamespace]: appTranslations.es }),
    },
    hi: {
      shared: sharedHi,
      ...(appTranslations.hi && { [appNamespace]: appTranslations.hi }),
    },
    ar: {
      shared: sharedAr,
      ...(appTranslations.ar && { [appNamespace]: appTranslations.ar }),
    },
  };

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      supportedLngs: SUPPORTED_LANGUAGES,
      defaultNS: 'shared',
      ns: ['shared', appNamespace].filter(Boolean),
      interpolation: {
        escapeValue: false, // React already escapes
      },
      keySeparator: false, // Keys use literal dots (e.g., "admin.sidebar.users"), not nesting
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'polyguardLanguage',
        caches: ['localStorage'],
      },
      initImmediate: false, // Initialize synchronously so translations are ready before first render
    });

  return i18n;
}

export { SUPPORTED_LANGUAGES };
export default i18n;
